<div
  class="warning-wrapper"
  *ngIf="!crossKeyHierarchy && !ownOperatingKey && !onlyTree && !budgetHierarchy && !showDealerMasterKeyTree"
>
  <div class="info">
    <div class="col">
      <ul>
        <li>
          Budget calculations are accurate for systems until the pin count is exceeded. IE... 5Pin = 5D, 6Pin = 6D, 7pin
          = 7D.
        </li>
        <li>In the future, the application will contain budget calculations for systems exceeding one keyway.</li>
      </ul>
    </div>
  </div>
</div>

<div *ngIf="!onlyTree" class="titles" [ngClass]="{ 'full-height': !crossKeyHierarchy && !ownOperatingKey, 'dealer': showDealerMasterKeyTree }">
  <span class="key-set-symbol">Keyset Symbol</span>

  <div *ngIf="showDealerMasterKeyTree" class="dealer-tmk-col">
    <span *ngIf="showDealerMasterKeyTree && keySystem?.constructionTypeId && keySystem?.constructionTypeId !== 1"
    >Active TMK</span
  >
  </div>
  <!-- <span *ngIf="showDealerMasterKeyTree && keySystem?.constructionTypeId && keySystem?.constructionTypeId !== 1"
    >Active TMK</span
  > -->

  <span *ngIf="!crossKeyHierarchy" [class.dealer-col]="showDealerMasterKeyTree">Key Section</span>

  <span *ngIf="!crossKeyHierarchy && !showDealerMasterKeyTree">Assigned</span>
  <span *ngIf="!crossKeyHierarchy && !showDealerMasterKeyTree">Future Key</span>
  <span *ngIf="!crossKeyHierarchy && !ownOperatingKey && !showDealerMasterKeyTree" class="expansion"
    >Total Change Keys
    <mat-icon
      class="info"
      [matTooltip]="
        'Add any additional changes that may be necessary to accommodate future growth or key loss. Additional changes direct to master, should be entered in the row of the particular master.'
      "
      >info_outlined
    </mat-icon>
  </span>

  <span
    *ngIf="isDevModeFn() && !crossKeyHierarchy && !ownOperatingKey && !showDealerMasterKeyTree"
    class="expansion budget"
    >Total Budget
    <mat-icon
      class="info"
      [matTooltip]="
        'The Total Budget accounts for 20% loss due to mechanical restrictions. Example on a 2D budget, if the actual number of changes assigned plus expansion equals 14, it will automatically be increased to a 3D budget.'
      "
      >info_outlined
    </mat-icon>
  </span>

  <span *ngIf="!showDealerMasterKeyTree">Notes</span>

  <span *ngIf="showDealerMasterKeyTree" class="dealer-col dealer-bitting-col">Bitting</span>

  <div class="spacer" *ngIf="!crossKeyHierarchy && !showDealerMasterKeyTree">
    <mat-icon
      *ngIf="crossKeyHierarchy && !ownOperatingKey"
      [matTooltip]="
        'Master Operator: Selecting this will only allow a master to be selected and the cylinder will be operated by the entire master. To select operators at the change key level, remove the Master Operator Selection. Residential systems will only be able to select operators by master.'
      "
      >info_outlined
    </mat-icon>
  </div>
</div>

<div class="dialog-container-content content" [style.height]="'calc(100% - ' + heightOffset + 'px)'">
  <div
    class="main"
    [ngClass]="{
      full: !onlyTree,
      'only-tree': onlyTree,
      'budget-hierarchy': budgetHierarchy,
      dealer: showDealerMasterKeyTree
    }"
  >
    <lib-menu-item
      *ngIf="!onlyTree && !showDealerMasterKeyTree && formattedHierarchyItems"
      [showChangeKeys]="showChangeKeys"
      [hierarchyItem]="formattedHierarchyItems"
      [keySystem]="keySystem"
      [crossKeyHierarchy]="crossKeyHierarchy"
      [ownOperatingKey]="ownOperatingKey"
      [isResidentialSystem]="isResidentialSystem"
      [budgetHierarchy]="budgetHierarchy"
      [keyways]="keyways"
      [structure]="structure"
      (selectKey)="selectIncludedParent($event)"
      (deleteItemAction)="deleteItem($event)"
      (deleteChildrenAction)="deleteChildren($event)"
      (patchItemAction)="patchItem($event)"
      (addChildAction)="addChild($event)"
    >
    </lib-menu-item>
    <div class="toggle-unassigned-keys" *ngIf="onlyTree && !showDealerMasterKeyTree && formattedHierarchyItems">
      <p>
        <mat-slide-toggle [color]="'primary'" (toggleChange)="toggleUnassignedKeys()"><img class="unassign-keys-icon" src="assets/images/unassigned_keys.png"  matTooltip="Show only Unassigned Keys"  alt="Unassigned Keys" />
        </mat-slide-toggle>
      </p>
    </div>
    <lib-master-key-tree
      *ngIf="onlyTree && !showDealerMasterKeyTree && formattedHierarchyItems"
      [showChangeKeys]="showChangeKeys"
      [showUnassignedKeys]="showUnassignedKeys"
      [showNoKeysMessage]="showNoKeysMessage"
      [hierarchyItem]="masterKeys"
      [keySystem]="keySystem"
      [crossKeyHierarchy]="crossKeyHierarchy"
      [ownOperatingKey]="ownOperatingKey"
      [isResidentialSystem]="isResidentialSystem"
      (selectKey)="selectIncludedParent($event)"
      (deleteItemAction)="deleteItem($event)"
      (deleteChildrenAction)="deleteChildren($event)"
      (patchItemAction)="patchItem($event)"
      (addChildAction)="addChild($event)"
    >
    </lib-master-key-tree>
    <!-- <lib-dealer-masterkey-tree
      *ngIf="showDealerMasterKeyTree && formattedHierarchyItems"
      [hierarchyItem]="formattedHierarchyItems"
      [structure]="structure"
      [keySystem]="keySystem"
      [keySections]="keyways"
      [dealerMasterKeys]="dealerMasterKeys"
      (patchItemAction)="patchItem($event)"
      (dealererror)="handleDealerError($event)"
      (isEditing)="isEditingFunction($event)"
    >
    </lib-dealer-masterkey-tree> -->
    <lib-dealer-masterkey-tree
      *ngIf="showDealerMasterKeyTree && formattedHierarchyItems"
      [hierarchyItem]="formattedHierarchyItems"
      [structure]="structure"
      [keySystem]="keySystem"
      [keySections]="keyways"
      [dealerMasterKeys]="dealerMasterKeys"
    >
    </lib-dealer-masterkey-tree>
  </div>
</div>

<div *ngIf="!onlyTree" class="fill"></div>
